import { descriptionConstants } from '../constants';
import { descriptionService } from '../../services';

export const descriptionActions = {
  descriptionsList,
  addDescription,
  getDescription,
  updateDescription
}

/*
ACTION: Descriptions List
*/
function descriptionsList(pageID, perPage) {
  return dispatch => {
    dispatch(request());
    return descriptionService.descriptionsList(pageID, perPage)
      .then(
        response => {
          dispatch(success(response.data.body.descriptions, response.data.body.data.total));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: descriptionConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: descriptionConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: descriptionConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Description
*/
function addDescription(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return descriptionService.addDescription(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: descriptionConstants.ADD_REQUEST } }
  function success(status) { return { type: descriptionConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: descriptionConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Description By ID
*/
function getDescription(descriptionID) {
  return dispatch => {
    dispatch(request());
    return descriptionService.getDescription(descriptionID)
      .then(
        response => {
          console.log(response);
          dispatch(success(response.data.body));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: descriptionConstants.GET_REQUEST } }
  function success(item) { return { type: descriptionConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: descriptionConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Description
*/
function updateDescription(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return descriptionService.updateDescription(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: descriptionConstants.UPDATE_REQUEST } }
  function success(status) { return { type: descriptionConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: descriptionConstants.UPDATE_FAILURE, error } }
}